import { NamedRoute } from "@/jenesys-types/routes/routes";

import { QueriesRoute } from "@/components/routes/queries/QueriesRoute";

export default (): NamedRoute => ({
  path: "queries",
  name: "queries.company",
  element: <QueriesRoute context="company" />
});
